module.exports = __webpack_public_path__ + "static/media/4.c1249b34.jpg";